import React from 'react';

const Loader = ({ 
  size = 'medium', 
  color = '#10b981', 
  fullScreen = false,
  text = '',
  variant = 'spinner' // 'spinner', 'dots', 'pulse', 'progress'
}) => {
  
  const getSizeValue = () => {
    switch(size) {
      case 'small': return '24px';
      case 'medium': return '40px';
      case 'large': return '60px';
      default: return '40px';
    }
  };

  const sizeValue = getSizeValue();

  // Spinner Loader
  if (variant === 'spinner') {
    return (
      <div style={fullScreen ? fullScreenContainerStyle : containerStyle}>
        <div style={spinnerStyle(sizeValue, color)} />
        {text && <span style={textStyle}>{text}</span>}
      </div>
    );
  }

  // Dots Loader
  if (variant === 'dots') {
    return (
      <div style={fullScreen ? fullScreenContainerStyle : containerStyle}>
        <div style={dotsContainerStyle}>
          <div style={dotStyle(color, 0)} />
          <div style={dotStyle(color, 0.2)} />
          <div style={dotStyle(color, 0.4)} />
        </div>
        {text && <span style={textStyle}>{text}</span>}
      </div>
    );
  }

  // Pulse Loader
  if (variant === 'pulse') {
    return (
      <div style={fullScreen ? fullScreenContainerStyle : containerStyle}>
        <div style={pulseStyle(sizeValue, color)} />
        {text && <span style={textStyle}>{text}</span>}
      </div>
    );
  }

  // Progress Bar Loader
  if (variant === 'progress') {
    return (
      <div style={fullScreen ? fullScreenContainerStyle : containerStyle}>
        <div style={progressContainerStyle}>
          <div style={progressBarStyle(color)} />
        </div>
        {text && <span style={textStyle}>{text}</span>}
      </div>
    );
  }

  return null;
};

// Styles
const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '20px',
};

const fullScreenContainerStyle = {
  ...containerStyle,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(4px)',
  zIndex: 9999,
  margin: 0,
};

// Spinner Styles
const spinnerStyle = (size, color) => ({
  width: size,
  height: size,
  border: `3px solid ${color}20`,
  borderTopColor: color,
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
});

// Dots Styles
const dotsContainerStyle = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center',
};

const dotStyle = (color, delay) => ({
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  backgroundColor: color,
  animation: `bounce 1.4s infinite ease-in-out ${delay}s`,
});

// Pulse Styles
const pulseStyle = (size, color) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: color,
  animation: 'pulse 1.5s ease-in-out infinite',
});

// Progress Bar Styles
const progressContainerStyle = {
  width: '200px',
  height: '4px',
  backgroundColor: '#e5e7eb',
  borderRadius: '2px',
  overflow: 'hidden',
};

const progressBarStyle = (color) => ({
  width: '30%',
  height: '100%',
  backgroundColor: color,
  borderRadius: '2px',
  animation: 'progress 1.5s ease-in-out infinite',
});

const textStyle = {
  fontSize: '14px',
  color: '#6b7280',
  fontWeight: 500,
  marginTop: '8px',
};

// Add global animations
const globalStyles = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @keyframes bounce {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
  }

  @keyframes pulse {
    0% { transform: scale(0.8); opacity: 0.5; }
    50% { transform: scale(1); opacity: 1; }
    100% { transform: scale(0.8); opacity: 0.5; }
  }

  @keyframes progress {
    0% { transform: translateX(-100%); }
    50% { transform: translateX(0); }
    100% { transform: translateX(100%); }
  }
`;

// Add styles to document head
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = globalStyles;
  document.head.appendChild(style);
}

export default Loader;